//angular
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

//material
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

//extensions
import { AppRoutingModule } from './app-routing.module';
import { NguCarousel, NguTileComponent, NguItemComponent, NguCarouselDefDirective, NguCarouselItemDirective, NguCarouselNextDirective, NguCarouselPrevDirective, NguCarouselPointDirective } from '@ngu/carousel';

//TSO
import { Player } from './objects/player';
import { Result } from './objects/result';
import { Group } from './objects/group';
import { EventInfo } from './objects/EventInfo';

//Social Plugin
import { SocialLoginModule, SocialAuthServiceConfig, GoogleSigninButtonModule } from "@abacritt/angularx-social-login";
import { GoogleLoginProvider, FacebookLoginProvider } from "@abacritt/angularx-social-login";

//solution
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { PlayerService } from './services/player.service';
import { GroupService } from './services/group.service';
import { DocumentService } from './services/document.service';
import { HomeComponent } from './components/home/home.component';
import { MobileAppComponent } from './components/mobile-app/mobile-app.component';
import { LoginDialogComponent } from './components/login-dialog/login-dialog.component';
import { EventService } from './services/event.service';
import { MigrationService } from './services/migration.service';
import { FlightedResults } from './objects/FlightedResults';
import { Skins } from './objects/skins';
import { PlayerScorecardComponent } from './components/player-scorecard/player-scorecard.component';
import { UtilityService } from './services/utility.service';
import { FileUtil } from './objects/fileUtil';
import { PlayerRoundsComponent } from './components/player-rounds/player-rounds.component';
import { CoursesService } from './services/courses.service';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { CollectPhoneDialogComponent } from './components/collect-phone-dialog/collect-phone-dialog.component';
import { PlayerProfileComponent } from './components/player-profile/player-profile.component';
import { NewGroupDialogComponent } from './components/new-group-dialog/new-group-dialog.component';
import { PaymentFormComponent } from './components/payment-form/payment-form.component';
import { MessageService } from './services/email.service';
import { PushNotificationDialogComponent } from './components/push-notification-dialog/push-notification-dialog.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { PlayVideoDialogComponent } from './components/play-video-dialog/play-video-dialog.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { environment } from '../environments/environment';
import { PlatformConnectStripeComponent } from './components/platform-connect-stripe/platform-connect-stripe.component';
import { HowToComponent } from './components/how-to/how-to.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { ProductsComponent } from './components/products/products.component';
import { EmailDialogComponent } from './components/email-dialog/email-dialog.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { TermsComponent } from './components/terms/terms.component';
import { ReturnsComponent } from './components/returns/returns.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { TryItFreeComponent } from './components/try-it-free/try-it-free.component';
import { SharedModule } from './modules/shared/shared.module';
import { ResultsSharedModule } from './modules/results-shared/results-shared.module';
import { StripeComponent } from './components/stripe/stripe.component';
import { MaterialsSharedModule } from './modules/materials-shared/materials-shared.module';
import { BossGolfComponent } from './components/boss-golf/boss-golf.component';
import { KickPuttComponent } from './components/kick-putt/kick-putt.component';
import { UploadServiceService } from './services/upload-service.service';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { RegisterComponent } from './components/register/register.component';
import { PlayerLookupComponent } from './components/player-lookup/player-lookup.component';
import { MatchPlayComponent } from './components/match-play/match-play.component';
import { SkinsComponent } from './components/skins/skins.component';
import { ScorecardComponent } from './modules/dashboard/scorecard/scorecard.component';
import { ScorecardLookupComponent } from './components/scorecard-lookup/scorecard-lookup.component';
import { BillingComponent } from './modules/shared/billing/billing.component';
import { HandicapPlusComponent } from './components/handicap-plus/handicap-plus.component';
import { PlayerProfileCreditsComponent } from './components/player-profile-credits/player-profile-credits.component';
import { ScorecardPreviewDialogComponent } from './components/scorecard-preview-dialog/scorecard-preview-dialog.component';

let facebookProviderId = environment.FACEBOOK_APP_ID;

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    MobileAppComponent,
    LoginDialogComponent,
    PlayerScorecardComponent,
    PlayerRoundsComponent,
    CreateAccountComponent,
    CollectPhoneDialogComponent,
    PlayerProfileComponent,
    NewGroupDialogComponent,
    PaymentFormComponent,
    PushNotificationDialogComponent,
    TestimonialsComponent,
    PlayVideoDialogComponent,
    PrivacyComponent,
    PlatformConnectStripeComponent,
    HowToComponent,
    NotificationsComponent,
    ProductsComponent,
    EmailDialogComponent,
    PricingComponent,
    TermsComponent,
    ReturnsComponent,
    ContactUsComponent,
    TryItFreeComponent,
    StripeComponent,
    BossGolfComponent,
    KickPuttComponent,
    LoginComponent,
    LogoutComponent,
    RegisterComponent,
    PlayerLookupComponent,
    MatchPlayComponent,
    SkinsComponent,
    ScorecardComponent,
    ScorecardLookupComponent,
    HandicapPlusComponent,
    PlayerProfileCreditsComponent,
    ScorecardPreviewDialogComponent,
  ],
  imports: [
    SharedModule,
    ResultsSharedModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SocialLoginModule,
    GoogleSigninButtonModule,
    NguCarousel,
    NguTileComponent,
    NguItemComponent,
    NguCarouselDefDirective,
    NguCarouselItemDirective,
    NguCarouselNextDirective,
    NguCarouselPrevDirective,
    NguCarouselPointDirective,
    MaterialsSharedModule,
    HammerModule,
  ],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', subscriptSizing: 'dynamic', floatLabel: 'always' } },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          { id: GoogleLoginProvider.PROVIDER_ID, provider: new GoogleLoginProvider("586433516567-3l2dqcosq7o8rsvna2kbtmb04f7sosc4.apps.googleusercontent.com") },
          { id: FacebookLoginProvider.PROVIDER_ID, provider: new FacebookLoginProvider(facebookProviderId) }
        ]
      } as SocialAuthServiceConfig
    },
    //{ provide: Window, useValue: window },
    DocumentService,
    PlayerService,
    EventService,
    MigrationService,
    GroupService,
    UtilityService,
    CoursesService,
    MessageService,
    UploadServiceService,
    Player,
    Group,
    Result,
    EventInfo,
    FlightedResults,
    Skins,
    FileUtil],
  bootstrap: [AppComponent]
})
export class AppModule { }
